import { faSpellCheck } from '@fortawesome/free-solid-svg-icons';
import { hideWhenReadOnlyRule } from '../commonRules';
import { ReviewFormModal } from './ReviewFormModal';
export const ReviewFormButton = {
    key: 'review',
    buttonStyle: 'default-1',
    icon: faSpellCheck,
    section: 'middle',
    prio: 5,
    text: 'Granska',
    ModalComponent: ReviewFormModal,
    defaultRules: [
        hideWhenReadOnlyRule
    ],
    onClick: async (row, inca, showModal)=>{
        await showModal();
    }
};
